import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

// Actions
import { hideModal } from 'cards/actions/modalActions';

// Utils
import ApiService from '@zola-helpers/client/dist/es/http/api';

// Components
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';

// Assets
import ContactInfoGif from 'assets/images/digitalSaveTheDate/contact-info.gif';

// Styles
import type { WProfileDataView } from '@zola/svc-web-api-ts-client';
import styles from './styles.module.less';

// Types

const GuestContactInfo = () => {
  const dispatch = useDispatch();

  const [fetchingSuperLinkData, setFetchingSuperLinkData] = useState<boolean>(true);
  const [hasSuperLink, setHasSuperLink] = useState<boolean>(false);

  useEffect(() => {
    ApiService.get<WProfileDataView>('/web-api/v1/profile/data')
      .then(profileData => {
        setFetchingSuperLinkData(false);
        setHasSuperLink(Boolean(profileData.stats_data?.guestlistStats?.super_link_created));
      })
      .catch(() => {});
  }, []);

  const onConfirm = () => {
    dispatch(hideModal());
    window.open('/wedding/manage/guests/collection-link/configure', '_blank');
  };

  return (
    !fetchingSuperLinkData && (
      <div className={styles.container}>
        <img className={styles.headerImg} src={ContactInfoGif} />
        <div className={styles.header}>
          Get addresses in a flash{' '}
          <span aria-label="Explosion Emoji" role="img">
            💥
          </span>
        </div>
        <div className={styles.content}>
          <ul className={styles.contactInfoList}>
            <li>We&apos;ll let you know when a guest responds</li>
            <li>Their info will automatically appear on your Zola guest list</li>
            <li>We&apos;ll even print their addresses on your invitation envelopes</li>
          </ul>
        </div>
        {hasSuperLink ? (
          <div className={styles.buttonContainer}>
            <ButtonV3 onClick={() => dispatch(hideModal())}>Got It</ButtonV3>
          </div>
        ) : (
          <div className={styles.buttonContainer}>
            <ButtonV3 variant="secondary" onClick={() => dispatch(hideModal())}>
              Maybe Later
            </ButtonV3>
            <ButtonV3 className={styles.buttonSpacing} onClick={onConfirm}>
              Get Started
            </ButtonV3>
          </div>
        )}
      </div>
    )
  );
};

export default {
  component: GuestContactInfo,
  className: styles.modalWidthOverride,
};
